<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-main>
    <v-container fluid>
      <v-row class="mt-12">
        <v-col cols="1" sm="1" md="1"></v-col>
        <v-col>
          <v-row align="center">
            <v-col cols="2" md="2">
              <a href="https://aexi.nl/" class="black--text" target="_blank">
                <img
                  class="ml-12 ml-md-0 login_img"
                  src="https://aexi.nl/wp-content/uploads/2026/01/logo-aexi_03.svg"
                  alt="aexi company logi"
                />
              </a>
            </v-col>
            <v-col cols="9" md="9"></v-col>
            <v-col cols="12" lg="4" md="5" class="aexi_blue_text mt-6">
              <!--              <v-btn @click="openHelpTest">Modeal</v-btn>-->
              <p>
                Grow your exports,
              </p>
              <span class="aexi_green_text">
                sustainably
              </span>
              <span class="ml-6 right-border"></span>

              <div class="login" v-if="is_compatible_browser()">
                <div class="login-screen">
                  <form>
                    <div class="login-form" v-on:keyup.enter="start_login_process">
                      <div v-if="!login_started">
                        <div class="control-group">
                          <label for="username"></label
                          ><input
                            id="username"
                            v-model="username"
                            class="login-field poppins"
                            placeholder="username"
                            type="text"
                          />
                          <label
                            class="login-field-icon fui-user"
                            for="login-name"
                          ></label>
                        </div>

                        <div class="control-group">
                          <label for="password"></label
                          ><input
                            id="password"
                            v-model="password"
                            autocomplete="on"
                            class="login-field"
                            placeholder="password"
                            type="password"
                          />
                          <label
                            class="login-field-icon fui-lock"
                            for="login-pass"
                          ></label>
                        </div>

                        <v-tooltip bottom :disabled="policy_accepted || (!policy_agree_false_text && !policy_agree_true_text)">
                          <template v-slot:activator="{ on, attrs }">
                            <div v-on="on" v-bind="attrs">
                              <v-btn
                                id="login"
                                color="#9bbc32"
                                class="btn btn-large btn-block aexi_green_background poppins"
                                :disabled="!policy_accepted && (!!policy_agree_false_text || !!policy_agree_true_text)"
                                @click="start_login_process_local"
                                >LOG IN
                              </v-btn>
                            </div>
                          </template>
                          <span>Please accept the privacy policy below</span>
                        </v-tooltip>

                        <v-checkbox
                          class="shrink mt-1 mb-0 checksize ml-2 text-right poppins"
                          v-model="clear_casch_selected"
                          label="Clear Cache on Login"
                        ></v-checkbox>

                        <v-checkbox
                          v-if="policy_agree_false_text || policy_agree_true_text"
                          class="shrink mt-0 mb-0 checksize ml-2 text-right poppins"
                          v-model="policy_accepted"
                          :label="policyCheckboxLabel"
                        ></v-checkbox>
                        <div
                          v-if="policyHtmlContent"
                          class="ml-2 mt-0 poppins policy-content"
                          v-html="policyHtmlContent"
                        ></div>
                      </div>
                      <div v-else class="trade-blue-text">
                        <v-progress-linear
                          indeterminate
                          color="rgba(108, 176, 61)"
                        ></v-progress-linear>
                        <div class="mt-12 mb-12  aexi_blue_text text-h4">
                          Logging in please be patient..
                          <v-progress-circular
                            :width="3"
                            color="rgba(108, 176, 61)"
                            indeterminate
                          ></v-progress-circular>
                        </div>

                        <v-progress-linear
                          indeterminate
                          color="rgba(108, 176, 61)"
                        ></v-progress-linear>
                      </div>
                      <template v-if="login_error && backend_alive" class="text-center">
                        <v-snackbar
                          v-model="login_error"
                          :timeout="4000"
                          centered
                          color="red lighten-1"
                          shaped
                        >
                          <h3 class="text-center pa-2 black--text lighten-2">
                            Incorrect username or password.
                          </h3>
                          <!-- /.caption -->
                        </v-snackbar>
                      </template>
                    </div>
                  </form>
                </div>
              </div>
              <div v-else class="mr-12 mt-12">
                <browser_compat_box />
              </div>
            </v-col>
            <v-col cols="12" lg="5" md="7" class="">
              <template v-if="article !== 'error'">
                <template v-if="article.Title" class="pa-2 ma-2">
                  <h1 v-if="article.Title" class="aexi_green_text_only">
                    {{ article.Title }}
                  </h1>

                  <p class="aexi_green_text_only font-italic">{{ article.Headline }}</p>
                  <p class="aexi_blue_text_only">
                    {{ article.p1 }}
                  </p>
                  <p class="aexi_dark_text_only">
                    {{ article.p2 }}
                  </p>

                  <p class="aexi_dark_text_only">{{ article.p3 }}</p>

                  <a :href="article.readMoreLink" class="black--text" target="_blank"
                    >Read more</a
                  >
                </template>
              </template>
            </v-col>
            <v-col align="center">
              <v-img
                class="ml-4 ml-sm-12"
                src="../../assets/img/half-X01-1.png"
                width="200"
              ></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-6" align="center" justify="center">
        <v-col cols="1" sm="1" md="1"></v-col>
        <v-col >
          <div class="login-page-content" v-html="loginPageContent"></div>
        </v-col>
        <v-col cols="1" sm="1" md="1"></v-col>
      </v-row>
      <applcation_selector
        :select_application_open.sync="$store.state.app.application_selector_open"
      />
    </v-container>
  </v-main>
</template>

<script>
import login from '@/components/application-level/mixins/login';
import browser_compat_box from '@/components/application-level/js_functions/browser_compat_box.vue';
import applcation_selector from '@/components/application-level/application-selector/applcation_selector.vue';
// import dialogDownloadWord from "@/components/application-level/helper-components/dialog-download-word.vue";

export default {
  name: 'loginDialogAexi2',
  // eslint-disable-next-line vue/no-unused-components
  components: {applcation_selector, browser_compat_box},
  mixins: [login],
  mounted() {
    this.login_started = false;
    this.policy_accepted = this.getCookie('policy_accepted') === 'true';
    const referrer = this.$route.query.referrer || 'aexi-2';
    this.loadLoginPageContent(referrer).then(content => {
      this.loginPageContent = content;
    });
  },
  methods: {
    start_login_process_local() {
      this.login_started = true;
      this.start_login_process().then(v => (this.login_started = v));
    },
  },
  data() {
    return {
      login_started: false,
    };
  },
};
</script>

<style scoped>
*:focus {
  outline: none;
}

body {
  font-family: 'Poppins';
  background-color: #3498db;
  padding: 50px;
}

p {
  font-family: 'Poppins';
}

.aexi_green_background {
  color: #9bbc32;
}

.aexi_green_text {
  font-family: 'Poppins';
  font-weight: 800;
  margin: 0;
  font-size: 1.5em;
  letter-spacing: -3px;
  color: #9bbc32;
}

.aexi_green_text_only {
  font-family: 'Poppins';
  color: #9bbc32;
}

.aexi_blue_text_only {
  font-family: 'Poppins';
  color: #1d2d4f;
  font-size: 1.3em;
}

.aexi_dark_text_only {
  font-family: 'Poppins';
  color: #1d242d;
  font-size: 1.2em;
  font-weight: 200;
}

.aexi_blue_text {
  font-size: 40px;
  line-height: 40px;
  letter-spacing: -1px;
  color: #1d2d4f;
  font-family: 'Poppins';
  font-weight: 600;
}

.poppins {
  font-family: 'Poppins';
}

.dsm-link {
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 400;
  font-stretch: 100%;
  color: #808080;
  text-align: center;
}

.dsm-link-border {
  border-right: 1px solid lightgrey;
}

.article-border {
  /*border: 1px solid lightgrey;*/
  font-family: 'Poppins';
}

.dsm-header {
  background-image: url('../../assets/img/white-arrow.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: auto auto;
  color: #00ffff;
  font-family: 'Open Sans', Helvetica, Arial, Verdana, sans-serif;
  /*font-family: "Unica One", Helvetica, Arial, Verdana, sans-serif;*/
  text-transform: uppercase;
}

.login {
  width: 300px;
}

.login-screen {
  background-color: #ffffff;
  border-radius: 5px;
  margin-top: 50px;
}

.app-title {
  text-align: center;
  color: #24527a;
}

.login-form {
  text-align: center;
}

.control-group {
  margin-bottom: 10px;
}

input {
  text-align: center;
  background-color: #dfe3e4 !important;
  border: 2px solid transparent;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 200;
  padding: 10px 0;
  width: 280px;
  transition: border 0.5s;
}

input:focus {
  border: 2px solid #3498db !important;
  box-shadow: none;
}

.btn {
  border: 2px solid transparent;
  background: #991b1e;
  color: white;
  font-size: 16px;
  line-height: 25px;
  padding: 10px 0;
  text-decoration: none;
  text-shadow: none;
  border-radius: 3px;
  box-shadow: none;
  transition: 0.25s;
  display: block;
  width: 280px;
  margin: 0 auto;
}

.btn:hover {
  background-color: #1f3c5f;
}

.login-link {
  font-size: 19px;
  color: #444;
  display: block;
  text-decoration: none;
}

.login-link:hover {
  background-color: #e6e6e6;
  padding: 3px;
}

.slide-fade-enter-active {
  transition: all 2.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
 {
  transform: translateX(10px);
  opacity: 0;
}

.checksize {
  transform: scale(1);
  padding-left: 0;
  margin-left: 0;
}

.background-image {
  background: #6cb03d;
}

.right-border {
  border-right: 2px solid #9bbc32;
  height: 100%;
}

.login_img {
  width: 300px;
  height: auto;
}

.aexi_variant_label {
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 1.2em;
  color: #1d2d4f;
  text-align: center;
}

.policy-content {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
    line-height: 2;
}

.policy-content >>> p {
  text-align: left;
  margin-bottom: 4px;
  line-height: 1.3;
}

.checksize >>> .v-label {
  font-size: 12px;
}
</style>
